export default __webpack_public_path__ + "static/media/artichoke.4f3ec911.png";